import { Video, Calendar, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { gbp } from "@/lib/api";

const statusStyle = {
  confirmed: "bg-emerald-100 text-emerald-700",
  pending_payment: "bg-amber-100 text-amber-700",
  completed: "bg-slate-200 text-slate-600",
};

export function LessonCard({ lesson, who }) {
  const dt = new Date(lesson.scheduled_at);
  const paid = lesson.payment_status === "paid";
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 hover:shadow-md transition-shadow" data-testid={`lesson-card-${lesson.id}`}>
      <div className="flex items-start justify-between">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="font-display text-xl font-semibold text-[#595C2B]">{lesson.subject}</h3>
            <Badge className="bg-[#595C2B]/10 text-[#595C2B] hover:bg-[#595C2B]/10">{lesson.level}</Badge>
          </div>
          <p className="text-sm text-slate-500 mt-1">
            {who === "tutor" ? `Student: ${lesson.child_name}` : `Tutor: ${lesson.tutor_name}`}
          </p>
        </div>
        <Badge className={`${statusStyle[lesson.status] || "bg-slate-100 text-slate-600"} hover:opacity-100 capitalize`}>
          {lesson.status.replace("_", " ")}
        </Badge>
      </div>

      <div className="flex flex-wrap items-center gap-4 mt-4 text-sm text-slate-600">
        <span className="flex items-center gap-1.5"><Calendar className="h-4 w-4 text-[#BA8A30]" />{dt.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" })}</span>
        <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-[#BA8A30]" />{dt.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })} · {lesson.duration_min} min</span>
        {who === "parent" && <span className="font-semibold text-[#595C2B]">{gbp(lesson.amount)}</span>}
      </div>

      <div className="mt-5">
        {paid ? (
          <a href={lesson.meet_link} target="_blank" rel="noreferrer" data-testid={`join-meet-${lesson.id}`}>
            <Button className="rounded-full bg-[#595C2B] hover:bg-[#45481F] text-white btn-lift">
              <Video className="h-4 w-4 mr-2" /> Join Google Meet
            </Button>
          </a>
        ) : (
          <span className="text-sm text-amber-600 font-medium">Awaiting payment to confirm & unlock Meet link</span>
        )}
      </div>
    </div>
  );
}
